module.exports = __webpack_public_path__ + "static/img/Inspection21.4a045585.jpg";